module.exports = "gallery{height:100%}\n"